// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__WSD_z","tab":"Tabs_tab__1eGUW","tabActive":"Tabs_tabActive__faKb1"};